import { COLOR_BASE_GREY_10 } from '@audi/audi-ui-design-tokens';
import { Icon, Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

const StyledErrorMessage = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 16px;
	background-color: ${COLOR_BASE_GREY_10};
`;

export function ErrorMessage({ text }: { text: string }) {
	return (
		<StyledErrorMessage>
			<Icon name="caution" size={'s'} />
			<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>{text}</Text>
		</StyledErrorMessage>
	);
}
